import { render, staticRenderFns } from "./ApprovalTable.vue?vue&type=template&id=403b3dae"
import script from "./ApprovalTable.vue?vue&type=script&lang=js"
export * from "./ApprovalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports